<div mat-dialog-title style="padding-right: 10px;" translate>Additional Details</div>
<mat-dialog-content style="max-height: none !important">
    <table width="500px">
        <tr *ngIf="SelectedFP.Course != '' && SelectedFP.Course != null">
            <td class="divCellHeading" style="padding-bottom:0px;width:125px;" translate>
                Course
            </td>
            <td class="divCellContent">
                {{SelectedFP.Course}}
            </td>
        </tr>
        <tr *ngIf="SelectedFP.CheckNumber != '' && SelectedFP.CheckNumber != null">
            <td class="divCellHeading" style="padding-bottom:0px;width:125px;" translate>
                Check Number
            </td>
            <td class="divCellContent">
                {{SelectedFP.CheckNumber}}
            </td>
        </tr>
        <tr *ngIf="SelectedFP.CheckDate != undefined && SelectedFP.CheckDate != null && SelectedFP.CheckDate != dateCheck && v10">
            <td class="divCellHeading" style="padding-bottom:0px;width:125px;" translate>
                Check Date
            </td>
            <td class="divCellContent">
                <p style="margin:0;">{{SelectedFP.CheckDate|date:'MM/dd/yy'}}</p>
            </td>
        </tr>
        <tr *ngIf="SelectedFP.NameOnCheck != '' && SelectedFP.NameOnCheck != null">
            <td class="divCellHeading" style="padding-bottom:0px;width:125px;" translate>
                Name On Check
            </td>
            <td class="divCellContent">
                {{SelectedFP.NameOnCheck}}
            </td>
        </tr>
        <tr *ngIf="SelectedFP.DueDate != undefined && SelectedFP.DueDate != null && SelectedFP.DueDate != dateCheck && v10">
            <td class="divCellHeading" style="padding-bottom:0px;width:125px;" translate>
                Due Date
            </td>
            <td class="divCellContent">
                <p style="margin:0;">{{SelectedFP.DueDate|date:'MM/dd/yy'}}</p>
            </td>
        </tr>
        <tr *ngIf="SelectedFP.Comments != '' && SelectedFP.Comments != null">
            <td colspan="2">
                <div class="divCellHeading" style="padding-top: 10px; font-size:14px;padding-bottom:0px;width:125px;" translate>
                    Comment:
                </div>
                <div style="padding-top:5px;" class="divCellContent">
                    {{SelectedFP.Comments}}
                </div>
            </td>
        </tr>
    </table>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-left'>
  </div>
  <div class='flex-footer-right'>
    <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeClick()" style="float:right"></tyl-button>
  </div>
</mat-dialog-actions>

